import { render, staticRenderFns } from "./MaterialStock.vue?vue&type=template&id=24aa69bd&scoped=true"
import script from "./MaterialStock.vue?vue&type=script&lang=js"
export * from "./MaterialStock.vue?vue&type=script&lang=js"
import style0 from "./MaterialStock.vue?vue&type=style&index=0&id=24aa69bd&prod&scoped=true&lang=css"
import style1 from "./MaterialStock.vue?vue&type=style&index=1&id=24aa69bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa69bd",
  null
  
)

export default component.exports